export default __webpack_public_path__ + "static/media/SPPL_Annual_Return_2024.31221097.pdf";